// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7bbd5162","164":"8f0c2fbe","453":"d855a71b","746":"90f69e9c","929":"123765a4","941":"b5e6219f","992":"e8216b9f"}[chunkId] + ".chunk.js";
};